module.exports = __webpack_public_path__ + "static/media/DSC_6555.4a9f5cb1.jpg";